export const ANALYTICS_MODULES = Object.freeze({
  ACCOUNT_MANAGEMENT: 'ACCOUNT_MANAGEMENT',
  ADMINISTRATION: 'ADMINISTRATION',
  APPEALS: 'APPEALS',
  BIDDING: 'BIDDING',
  COMPLIANCE: 'COMPLIANCE',
  CONFIGURATION: 'CONFIGURATION',
  CONTRACT_MANAGEMENT: 'CONTRACT_MANAGEMENT',
  DASHBOARD: 'DASHBOARD',
  E_LEARNING: 'E_LEARNING',
  EVALUATION: 'EVALUATION',
  HELP_DESK: 'HELP_DESK',
  INVESTIGATIONS: 'INVESTIGATIONS',
  PAYMENTS: 'PAYMENTS',
  PROCUREMENT_AUDIT: 'PROCUREMENT_AUDIT',
  PROCUREMENT_PLANNING: 'PROCUREMENT_PLANNING',
  PROCUREMENT_TRAIL: 'PROCUREMENT_TRAIL',
  REGISTRATION: 'REGISTRATION',
  REPORTING: 'REPORTING',
  REQUISITIONS: 'REQUISITIONS',
  REVERSE_AUCTION: 'REVERSE_AUCTION',
  SECURITY: 'SECURITY',
  SUPPLIER_MANAGEMENT: 'SUPPLIER_MANAGEMENT',
  SUSPENSIONS: 'SUSPENSIONS',
  TENDERING: 'TENDERING',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  WORKFLOW: 'WORKFLOW',
  GENERAL: 'GENERAL',
  OCDS: 'OCDS',
});

const ROUTE_HINTS = [
  [/dashboard|^home$/, ANALYTICS_MODULES.DASHBOARD],
  [/ocds|open.*contracting|record.*package|records|welcome/, ANALYTICS_MODULES.OCDS],
  [/report/, ANALYTICS_MODULES.REPORTING],
  [/e-?learning|course|lesson|assessment/, ANALYTICS_MODULES.E_LEARNING],
  [/helpdesk|ticket/, ANALYTICS_MODULES.HELP_DESK],
  [/contract/, ANALYTICS_MODULES.CONTRACT_MANAGEMENT],
  [/payment|transaction/, ANALYTICS_MODULES.PAYMENTS],
  [/annual.*procurement|procurement.*plan|budget/, ANALYTICS_MODULES.PROCUREMENT_PLANNING],
  [/procurement.*audit/, ANALYTICS_MODULES.PROCUREMENT_AUDIT],
  [/procurement.*trail/, ANALYTICS_MODULES.PROCUREMENT_TRAIL],
  [/evaluation/, ANALYTICS_MODULES.EVALUATION],
  [/tender/, ANALYTICS_MODULES.TENDERING],
  [/bid/, ANALYTICS_MODULES.BIDDING],
  [/requisition/, ANALYTICS_MODULES.REQUISITIONS],
  [/reverse.*auction|auction/, ANALYTICS_MODULES.REVERSE_AUCTION],
  [/configuration|province|district|constituency|ward|unspsc/, ANALYTICS_MODULES.CONFIGURATION],
  [/supplier/, ANALYTICS_MODULES.SUPPLIER_MANAGEMENT],
  [/registration|register/, ANALYTICS_MODULES.REGISTRATION],
  [/workflow|task/, ANALYTICS_MODULES.WORKFLOW],
  [/security|role|privilege/, ANALYTICS_MODULES.SECURITY],
  [/user/, ANALYTICS_MODULES.USER_MANAGEMENT],
  [/appeal/, ANALYTICS_MODULES.APPEALS],
  [/compliance/, ANALYTICS_MODULES.COMPLIANCE],
  [/investigation/, ANALYTICS_MODULES.INVESTIGATIONS],
  [/suspension|barring/, ANALYTICS_MODULES.SUSPENSIONS],
];

export function analyticsRoutes(module, routes, options = {}) {
  return routes.map((route) => decorate(route, module, options));
}

function decorate(route, defaultModule, options) {
  const analyticsModule = route.meta?.analyticsModule || defaultModule || inferModule(route);
  return {
    ...route,
    meta: {
      ...route.meta,
      analyticsModule,
      ...(options.trackAuthenticated ? { analyticsTrackAuthenticated: true } : {}),
    },
    children: route.children?.map((child) => decorate(child, analyticsModule, options)),
  };
}

function inferModule(route) {
  const value = `${String(route.name || '')} ${route.path || ''}`.toLowerCase();
  return ROUTE_HINTS.find(([pattern]) => pattern.test(value))?.[1] || ANALYTICS_MODULES.GENERAL;
}

